<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <img src="/Content/svg/client-logo.svg" class="ir-logo" (click)="goToDashboard()" />
    </div>
    <div class="ir-line--right">
      <div>
        <ng-container *ngIf="buttons$ | async as buttons">
          <div *ngFor="let button of buttons" class="ir-btn th-btn-normal" (click)="openLink(button.link)">
            <i class="material-icons">{{ button.icon }}</i>
          </div>
        </ng-container>
        <div class="ir-btn th-btn-normal" (click)="goToDashboard()" title="{{ 'home.dashboard' | translate }}">
          <i class="material-icons">arrow_back</i>
        </div>
        <div class="ir-btn th-btn-normal" (click)="openLanguagesSelector()">
          <span>{{ currentLanguage }}</span>
        </div>
        <div class="ir-btn th-btn-normal" [routerLink]="['/inspectionbrowser/settings']">
          <i class="material-icons">settings</i>
        </div>
        <div class="ir-btn th-btn-normal" *ngIf="currentPerson && currentPerson.applicationTypes.length > 1" (click)="openAppSelector()">
          <i class="material-icons">apps</i>
        </div>
        <div class="ir-btn th-btn-normal" (click)="logout()">
          <i class="material-icons">power_settings_new</i>
        </div>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ 'home.administration' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-section--admin th-section--admin">
    <div class="ir-content-fixed th-content">
      <h1>
        <span *ngIf="currentPerson && currentPerson.name">{{ currentPerson.name }}</span>
        <span *ngIf="currentPerson && !currentPerson.name">{{ currentPerson.email }}</span>
      </h1>
      <div class="ir-position--b th-home">
        <div class="ir-bloc ir-ph4 ir-pv4">
          <div class="ir-row">
            <ng-container *ngIf="isInstallation; else buttons">
              <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3 ir-ph4 ir-pv4">
                <div
                  [permissions]="[['visible', 'manage.template']]"
                  [routerLink]="['/inspectionbrowser/templates/parents']"
                  class="ir-btn ir-btn--big ir-btn--block th-btn-action"
                >
                  <div class="button-conent">
                    <i class="material-icons">folder_special</i>
                    <span>{{ 'home.parent-templates' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3 ir-ph4 ir-pv4">
                <div
                  [permissions]="[['visible', 'manage.template']]"
                  [routerLink]="['/inspectionbrowser/templates/children']"
                  class="ir-btn ir-btn--big ir-btn--block th-btn-action"
                >
                  <div class="button-conent">
                    <i class="material-icons">folder</i>
                    <span>{{ 'home.templates' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3 ir-ph4 ir-pv4">
                <div
                  [permissions]="[['visible', 'manage.people']]"
                  [routerLink]="['/inspectionbrowser/people']"
                  class="ir-btn ir-btn--big ir-btn--block th-btn-action"
                >
                  <div class="button-conent">
                    <i class="material-icons">people</i>
                    <span>{{ 'home.people' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3 ir-ph4 ir-pv4">
                <div
                  [permissions]="[['visible', 'manage.inspection']]"
                  (click)="goToInspections()"
                  class="ir-btn ir-btn--big ir-btn--block th-btn-action"
                >
                  <div class="button-conent">
                    <i class="material-icons">playlist_play</i>
                    <span>{{ inspectionsLabel | translate }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <ng-template #buttons>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div
                [permissions]="[['visible', 'manage.template']]"
                [routerLink]="['/inspectionbrowser/templates']"
                class="ir-btn ir-btn--big ir-btn--block th-btn-action"
              >
                <div class="button-conent">
                  <i class="material-icons">folder</i>
                  <span>{{ 'home.templates' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div
                [permissions]="[['visible', 'manage.people']]"
                [routerLink]="['/inspectionbrowser/people']"
                class="ir-btn ir-btn--big ir-btn--block th-btn-action"
              >
                <div class="button-conent">
                  <i class="material-icons">people</i>
                  <span>{{ 'home.people' | translate }}</span>
                </div>
              </div>
            </div>
            <div class="ir-cell-tin4 ir-cell-sma4 ir-cell-mid4 ir-cell-lar4 ir-ph4 ir-pv4">
              <div
                [permissions]="[['visible', 'manage.inspection']]"
                (click)="goToInspections()"
                class="ir-btn ir-btn--big ir-btn--block th-btn-action"
              >
                <div class="button-conent">
                  <i class="material-icons">playlist_play</i>
                  <span>{{ inspectionsLabel | translate }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<modal (modalOutput)="selectLanguagesMenu($event)" #languagesModal></modal>
<modal (modalOutput)="selectAppMenu($event)" #appModal></modal>
